import { useEffect, useState } from 'react';

import QuickActions from "./quickActions";

import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const MobileHome = ({ userData, propertiesData, selectedProperty, onPropertyChange, units, selectedUnit, onUnitChange, isUnitsLoading }) => {
    const [images, setImages] = useState([]);

    const user = userData.user.userData.givenName;
    const userName = user && user.charAt(0).toUpperCase() + user.slice(1);

    useEffect(() => {
        if (selectedProperty.images && selectedProperty.images.length > 0) {
            setImages(selectedProperty.images);
        }
    }, [selectedProperty]);

    return (
        <>
            <div className="flex flex-col items-center mb-4">
                {images.length > 0 ? (
                    images.map((photo) => (
                        <img
                            key={photo._id}
                            src={photo.key}
                            alt={photo.altText || "Property Photo"}
                            className="rounded-[15px] h-[150px] w-full object-cover"
                        />
                    ))
                ) : (
                    null
                )}
            </div>
            <div className="flex flex-row items-center bg-[#445485] mb-4 rounded-[15px]">
                <div className="flex flex-col items-center p-6 w-full">
                    <div className="r-welcome-box-text text-center">
                        <h1 className="r-welcome-title text-xl">Welcome back, {userName}!</h1>
                        <p className="r-welcome-label mt-1">This is your property portfolio for the month.</p>
                    </div>
                    <div className="r-welcome-box-overview">
                        <div className="property-overview">
                            <Autocomplete
                                options={propertiesData || []}
                                value={selectedProperty}
                                onChange={(e, newVal) => onPropertyChange(newVal)}
                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                getOptionLabel={(option) =>
                                    typeof option === 'string' ? option : option?.label || ''
                                }
                                renderInput={params => (
                                    <TextField {...params}
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: '#fff',
                                            borderRadius: '9.5px',
                                            mb: 1,
                                            width: '330px',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '9.5px',
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: '#888',
                                            },
                                        }} />
                                )}
                            />
                            <Autocomplete
                                options={units || []}
                                value={selectedUnit}
                                onChange={(e, newValue) => onUnitChange(newValue)}
                                getOptionLabel={(option) => option.unitNumber || ''}
                                isOptionEqualToValue={(option, value) => option?._id === value?._id}
                                disabled={!selectedProperty || isUnitsLoading}
                                loading={isUnitsLoading}
                                popupIcon={<ExpandMoreIcon sx={{ color: '#000' }} />}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: '#fff',
                                            borderRadius: '9.5px',
                                            width: '330px',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '9.5px',
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: '#888',
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isUnitsLoading && <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} />}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-4">
                <QuickActions
                    account={userData.user.userData}
                    selectedProperty={selectedProperty}
                    unitOptions={units}
                />
            </div>
            <hr />
        </>
    );
}

export default MobileHome;